import * as main from './main';

export = main;